export enum Format {
  text = 'text',
  json = 'json'
}

export function getJSONFormat(data: string) {
  try {
    return JSON.stringify(JSON.parse(data), undefined, 4)
  } catch (e) {
    return ''
  }
}

export function getContentByFormat(data: string, format: Format) {
  switch (format) {
    case Format.json:
      return getJSONFormat(data)
    case Format.text:
    default:
      return data || ''
  }
}
